/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  MetaCategorySuggestionControllerSuggestMutationRequest,
  MetaCategorySuggestionControllerSuggestMutationResponse,
  MetaCategorySuggestionControllerSuggestPathParams,
  MetaCategorySuggestionControllerSuggest401,
  MetaCategorySuggestionControllerSuggest404,
} from '../../types/MetaCategorySuggestionControllerSuggest.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { metaCategorySuggestionSuggest } from '../../methods/metaCategorySuggestionSuggest.ts';
import { useMutation } from '@tanstack/react-query';

export const metaCategorySuggestionSuggestMutationKey = () =>
  [{ url: '/api/user/telegram/category/meta/:metaCategoryId/suggestions' }] as const;

export type MetaCategorySuggestionSuggestMutationKey = ReturnType<typeof metaCategorySuggestionSuggestMutationKey>;

/**
 * {@link /api/user/telegram/category/meta/:metaCategoryId/suggestions}
 */
export function useMetaCategorySuggestionSuggest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      MetaCategorySuggestionControllerSuggestMutationResponse,
      ResponseErrorConfig<MetaCategorySuggestionControllerSuggest401 | MetaCategorySuggestionControllerSuggest404>,
      {
        metaCategoryId: MetaCategorySuggestionControllerSuggestPathParams['metaCategoryId'];
        data: MetaCategorySuggestionControllerSuggestMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<MetaCategorySuggestionControllerSuggestMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? metaCategorySuggestionSuggestMutationKey();

  return useMutation<
    MetaCategorySuggestionControllerSuggestMutationResponse,
    ResponseErrorConfig<MetaCategorySuggestionControllerSuggest401 | MetaCategorySuggestionControllerSuggest404>,
    {
      metaCategoryId: MetaCategorySuggestionControllerSuggestPathParams['metaCategoryId'];
      data: MetaCategorySuggestionControllerSuggestMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ metaCategoryId, data }) => {
        return metaCategorySuggestionSuggest(metaCategoryId, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
